import { render, staticRenderFns } from "./CapterraReviewCard.vue?vue&type=template&id=d6136d4c&scoped=true"
import script from "./CapterraReviewCard.vue?vue&type=script&lang=js"
export * from "./CapterraReviewCard.vue?vue&type=script&lang=js"
import style0 from "./CapterraReviewCard.vue?vue&type=style&index=0&id=d6136d4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6136d4c",
  null
  
)

export default component.exports